export default __webpack_public_path__ + "static/media/028-zero.175de38b.svg";